import { create } from 'zustand'
import { AxiosError } from 'axios'

interface ErrorOptions {
    message?: string
    retry?: () => Promise<unknown>
    axiosError?: AxiosError
    showModal?: boolean
    onReset?: () => void
}

interface ErrorStore extends ErrorOptions {
    message?: string
    retry?: () => Promise<void>
    handleRetry: () => Promise<void>
    reset: () => void
    setAppError: (options: ErrorOptions) => void
}

export const useErrorStore = create<ErrorStore>((set, get) => ({
    showModal: false,
    handleRetry: async () => {
        const retry = get().retry
        if (retry) {
            get().reset()
            await retry()
        }
    },
    reset: () => {
        set(state => ({
            ...state,
            message: undefined,
            retry: undefined,
            showModal: false
        }))
        // @ts-ignore
        get().onReset && get().onReset()
    },
    setAppError: options => {
        // @ts-ignore
        set(state => ({ ...state, ...options }))
    }
}))
